module.exports.Genesis = {};